/**
 * Cross-realm-safe error name extractor.
 *
 * Duck-types the `name` property instead of relying on `instanceof Error`,
 * which fails across window/iframe/VM boundaries (happy-dom, jsdom test envs,
 * extension sandboxes). Returns `'unknown'` for non-Error values.
 *
 * Canonical helper — import this instead of re-implementing
 * `err instanceof Error ? err.name : 'unknown'` inline. Re-exported from
 * `call/gum-pipeline.ts` for existing consumers; new consumers should import
 * directly from here to avoid pulling in the call/audio dependency chain.
 */
export function errName(err: unknown): string {
	const name = (err as { name?: unknown } | null)?.name;
	return typeof name === 'string' ? name : 'unknown';
}
